import React, { useRef } from 'react';
import { PrintContextConsumer } from 'react-to-print';
import ReactToPrint from 'react-to-print';
import { Box , Container, Typography, Button } from '@mui/material';

const pageStyle = `
    html
    {
        background-color: #FFFFFF; 
        margin: 0mm;  /* this affects the margin on the html before sending to printer */
    }
    body
    {
        padding: 12px auto; /* margin you want for the content */
    }
    
    @page {
        size: 80mm auto;
        margin: 0mm 4mm;
        padding: 0mm 4mm;
    }

    @media all {
        .page-break {
        display: none;
        padding: 0mm auto;
        }
    }

    @media print {
        .page-break {
            page-break-before: always;
            padding: 0px auto;
        }
        html, body {
            height: auto;
            font-size: 11pt;
        }
        .hide{
            display: none;
        }
        .box {

        }
        .header {
            display: flex;
            justify-content: space-between;
        }
        .header-invoice {
            display: flex;
        }
        .title {
            font-size: 12px;
            text-align: center;
        }
        .id-text {
            font-size: 9px;
            color: grey;
        }
        .section {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: center;
            margin: 16px auto;
            width: 100%;
        }
        .typography {

        }
        .two-column-section {
            display: flex;
            width: 100%;
        }
        .two-column-section-column {
            display: flex;
            flex-direction: column;
            width: 50%;
        }
        .hr {
            border-top: 1px solid #EEEEEE;
        }
        .section-right-align {
            text-align: right;
        }
        .table-header {
            border-top: 1px solid #EEEEEE;
            color: grey;
            display: flex;
            font-size: 12px;
            font-weight: bold;
            margin-bottom: 12px;
            padding: 8px auto;
        }
        .item-table-row-name {
            width: 70%;
        }
        .item-table-row-qty {
            width: 10%;
        }
        .item-table-row-price {
            width: 10%;
        }
        .item-table-row-tax {
            width: 10%;
        }
        .row1 {
            width: 27%;
        }
        .row2 {
            width: 15%;
        }
        .row3 {
            width: 15%;
        }
        .row4 {
            width: 20%;
        }
        .row5 {
            width: 27%;
        }
        .table-item {
            display: flex;
            border-top: 1px solid #EEEEEE;
            padding: 8px auto;
        }
    }
`;

let rootContent = null;
const storeContent = {};

function readContent(inputFetch, output) {

    inputFetch.forEach((el) => {

        let recordContent = {
            en: String,
            ch: String,
            de: String,
            image: Array
        }

        recordContent.en = el.fields.en;
        recordContent.ch = el.fields.ch;
        recordContent.de = el.fields.de;
        recordContent.image = el.fields.image;

        output[`${el.fields.name}`] = recordContent;

        return;
    });
    return;
}

function createData(
    name: string,
    quantity: number,
    price: number,
    tax: string,
) {
    return { name, quantity, price, tax };
}

let data = [];

function Table(props) {
    return (
        <div className="section">
            <div className="table-header">
                <div className="item-table-row-name">
                    <p className="typography">Product Name</p>
                </div>
                <div className="item-table-row-qty">
                    <p className="typography">Qty</p>
                </div>
                <div className="item-table-row-price">
                    <p className="typography">Price</p>
                </div>
                <div className="item-table-row-tax">
                    <p className="typography">Tax</p>
                </div>
            </div>
            {
                props.dataInput?.map((el, index) => (
                    <div className="table-item" key={index}>
                        <div className="item-table-row-name">
                            <p className="typography">
                                {el.name}
                            </p>
                        </div>
                        <div className="item-table-row-qty">
                            <p className="typography">
                                {el.quantity}
                            </p>
                        </div>
                        <div className="item-table-row-price">
                            <p className="typography">
                                {el.price}
                            </p>
                        </div>
                        <div className="item-table-row-tax">
                            <p className="typography">
                                {el.tax}
                            </p>
                        </div>
                    </div>
                ))
            }
        </div>
    );
}

function TaxTable(props) {

    let aSum = 0;
    let aNet = 0;
    let aInclude = 0;

    let bSum = 0;
    let bNet = 0;
    let bInclude = 0;

    props.dataInput.forEach((el) =>{
        aSum = aSum + Math.round(Number(el.fields['A-sum']) * el.fields['quantity'] * 100) / 100 ;
        aNet = aNet + Math.round(Number(el.fields['A-net']) * el.fields['quantity'] * 100) / 100;

        bSum = bSum + Math.round(Number(el.fields['B-sum']) * el.fields['quantity'] * 100) / 100;
        bNet = bNet + Math.round(Number(el.fields['B-net']) * el.fields['quantity'] * 100) / 100;
    })

    return (
        <div className="box">
            <div className="table-header">
                <div className="row1">
                    <p className="typography">Tax Type</p>
                </div>
                <div className="row2">
                    <p className="typography">Tax Value</p>
                </div>
                <div className="row3">
                    <p className="typography">Gross</p>
                </div>
                <div className="row4">
                    <p className="typography">Net</p>
                </div>
                <div className="row5">
                    <p className="typography">include</p>
                </div>
            </div>

            <div className="table-item">
                <div className="row1">
                    <p className="typography">
                        A
                    </p>
                </div>
                <div className="row2">
                    <p className="typography">
                        19%
                    </p>
                </div>
                <div className="row3">
                    <p className="typography">
                        {Math.round(aSum * 100) / 100}
                    </p>
                </div>
                <div className="row4">
                    <p className="typography">
                        {Math.round(aNet * 100) / 100}
                    </p>
                </div>
                <div className="row5">
                    <p className="typography">
                        {Math.round((aSum - aNet) * 100) / 100}
                    </p>
                </div>
            </div>

            <div className="table-item">
                <div className="row1">
                    <p className="typography">
                        B
                    </p>
                </div>
                <div className="row2">
                    <p className="typography">
                        7%
                    </p>
                </div>
                <div className="row3">
                    <p className="typography">
                        {Math.round(bSum * 100) / 100}
                    </p>
                </div>
                <div className="row4">
                    <p className="typography">
                        {Math.round(bNet * 100) / 100}
                    </p>
                </div>
                <div className="row5">
                    <p className="typography">
                        {Math.round((bSum - bNet) * 100) / 100}
                    </p>
                </div>
            </div>
        </div>
    );
}

function readData(orderInput, dataOutput){
    orderInput.forEach((el) => {
        dataOutput.push(
            createData(
                `${el.fields.name}${el.fields.size ? `, ${el.fields.size}` : ''}${el.fields.sugar ? `, ${el.fields.sugar}` : ''}${el.fields.temperature ? `, ${el.fields.temperature}` : ''}`,
                el.fields['quantity'],
                el.fields['original-price'],
                el.fields.tax
            )
        );

        if(el.fields['toppings-1']){
            dataOutput.push(
                createData(
                    el.fields['toppings-1'],
                    el.fields['quantity'],
                    el.fields['toppings-1-price'],
                    el.fields['toppings-1-tax']
                )
            );
        }
        if(el.fields['toppings-2']){
            dataOutput.push(
                createData(
                    el.fields['toppings-2'],
                    el.fields['quantity'],
                    el.fields['toppings-2-price'],
                    el.fields['toppings-2-tax']
                )
            );
            
        }
        if(el.fields['toppings-3']){
            dataOutput.push(
                createData(
                    el.fields['toppings-3'],
                    el.fields['quantity'],
                    el.fields['toppings-3-price'],
                    el.fields['toppings-3-tax']
                )
            );
        }
        if(el.fields.customization){
            dataOutput.push(
                createData(
                    el.fields['customization'],
                    el.fields['quantity'],
                    el.fields['customization-price'],
                    el.fields['customization-tax']
                )
            );
        }
        if(el.fields['discount-name']){
            dataOutput.push(
                createData(
                    el.fields['discount-name'],
                    el.fields['quantity'],
                    `- ${el.fields['discounted-price']}`,
                    ''
                )
            );
        }
    })
}

function InvoicePrinter (props) {

    const componentRef = useRef();

    rootContent = props.invoiceContent;
    readContent(props.storeContent, storeContent);

    data = [];
    readData(props.order, data);

    return(
        <>
            {   props.order.length !== 0 && props.invoiceContent && storeContent && rootContent &&
                <div >
                    <ReactToPrint
                        pageStyle={pageStyle}
                        trigger={() => 
                            <Button>
                                {props.invoiceContent['print-invoice'][`${props.language}`]}
                            </Button>
                        }
                        content={() => componentRef.current}
                    />
                    <div 
                    style={{ display: "none" }} 
                    className="page-break" 
                    >
                        <div ref={componentRef}>
                            <div className="header page-break">
                                <div className="header-invoice">
                                    <p className="title">
                                        Invoice
                                    </p>
                                    <p className="id-text">
                                        {`#${props.order[0].fields['order-name']}-${props.order[0].fields["index"]}`}
                                    </p>
                                </div>
                            </div>

                            <div className="section">
                                <p className="typography">
                                    {storeContent.store.en}
                                </p>
                                <p className="typography">
                                    {storeContent.address.en}
                                </p>
                                {   storeContent['tax-number'].en &&
                                    <p className="typography">
                                        {`${rootContent['tax-number'].en}: ${storeContent['tax-number'].en}`}
                                    </p>
                                }
                                {   storeContent.instagram.en &&
                                    <p className="typography">
                                        {`${rootContent.instagram.en}: ${storeContent.instagram.en}`}
                                    </p>
                                }
                                {   storeContent.facebook.en &&
                                    <p className="typography">
                                        {`${rootContent.facebook.en}: ${storeContent.facebook.en}`}
                                    </p>
                                }
                            </div>

                            <div className="section">
                                <p className="typography">
                                    {rootContent.title.en}
                                </p>
                                <div className="two-column-section">
                                    <div className="two-column-section-column">
                                        <p className="typography">
                                            {rootContent['invoice-id'].en}
                                        </p>
                                        <p className="typography">
                                            {rootContent.date.en}
                                        </p>
                                        <p className="typography">
                                            {rootContent.payment.en}
                                        </p>
                                        <p className="typography">
                                            {rootContent.currency.en}
                                        </p>
                                    </div>
                                    <div className="two-column-section-column">
                                        <p className="typography">
                                            {props.order[0].fields.id}
                                        </p>
                                        <p className="typography">
                                            {props.order[0].fields.created}
                                        </p>
                                        <p className="typography">
                                            {props.order[0].fields.payment}
                                        </p>
                                        <p className="typography">
                                            {storeContent.currency.en}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="hr"></div> */}

                            {   data !== [] &&
                                <Table dataInput={data} ></Table>
                            }

                            <div className="hr"></div>

                            <div className="section-right-align">
                                <p className="typography">
                                    {`${rootContent.sum.en}: ${props.order[0].fields['order-sum']}`}
                                </p>
                            </div>
                            <div className="section">
                                <TaxTable dataInput={props.order} ></TaxTable>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default InvoicePrinter;